// extracted by mini-css-extract-plugin
export default {"container":"modal_container__rkC9w","closeModal":"modal_closeModal__vO-t5"};